import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortByOrder'
})
export class SortByOrderPipe implements PipeTransform {

  transform<T>(value: T[], ...orders: string[]): T[] {
    if (value.length > 0) {
      orders.forEach(order => {
        if (Object.keys(value[0]).some(k => k === order)) {

          if (typeof (value[0][order]) === "string") {
            value = value.sort((a, b) => { return a[order].localeCompare(b[order]); });
          }

          if (typeof (value[0][order]) === "boolean") {
            value = value.sort(a => { return a[order] ? -1 : 1 });
          }
        }
      });
    }
    return value;
  }

}
